import React from "react";
import Section from "@/components/footer/Ifooter";

const WebScreen = ({ topSection }): JSX.Element => {
  return (
    <>
      <ul className="webScreen">
        {topSection &&
          topSection.map((section: Section, index: number) => (
            <li className="col-md-3 col-lg-4  link-category" key={index}>
              <button
                aria-controls="footer_accordion_section_1"
                id="footer_accordion_1_id"
              >
                <span className="titleHeading">{section.heading.split('~').map((line, index) => <span key={index}>{line}<br/></span>)} </span>
               
                <span className="icon plus-minus"></span>
              </button>
              <span className="header-underline"> </span>
              <div
                id="footer_accordion_section_1"
                role="region"
                aria-labelledby="footer_accordion_1_id"
              >
                <ul>
                  {section.data.map((links, subIndex) => (
                    <li key={subIndex}>
                      <a
                        href={links['disable']?undefined:links["href"]}
                        rel="noreferrer"
                        target={links['target']}
                        className={`list-default-color ${
                          links["disable"] ? "disableAnchorLink" : "list-name"
                        } ext-icon`}
                      >
                        {links["label"].split('~').map((line, index) => <span key={index}>
                          {line}<br/>
                          </span>)}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </li>
          ))}
      </ul>
    </>
  );
};

export default WebScreen;
